import z from 'zod';

/**
 * All env variables should be read from this file. Just add a new key to the schema
 * and add the config value. Consider using default values when possible.
 */

const AppConfigSchema = z.object({
  BRANCH_NAME: z.string().default('dev'),

  EXTRA_URLS: z
    .array(z.string())
    .default([
      'https://echo.elys.network',
      'https://e89b-l2d-y45-s66.elys.network',
      'https://testnet.elys.network',
    ]),

  BASE_URL: z.string().default('http://localhost:3000'),

  ENABLE_COMING_SOON: z.boolean().default(false),

  CHAIN_NETWORK: z.enum(['mainnet', 'testnet', 'devnet']).default('testnet'),

  RPC_URL: z.string().default(''),

  REST_URL: z.string().default(''),

  WS_URL: z.string().default(''),

  WEB3: z.object({
    clientId: z.string(),
  }),
});

export const _getAppConfig = () => {
  const baseURL =
    typeof window !== 'undefined'
      ? window.location.origin
      : process.env.CF_PAGES_URL ??
        process.env.NEXT_PUBLIC_VERCEL_URL ??
        process.env.NEXT_PUBLIC_BASE_URL;

  const CHAIN_NETWORK =
    typeof location !== 'undefined' &&
    location.hostname === 'devnet.elys.network'
      ? 'devnet'
      : process.env.NEXT_PUBLIC_CHAIN_NETWORK;

  const REST_URL =
    CHAIN_NETWORK === 'devnet'
      ? 'https://rest.devnet.elys.network'
      : process.env.NEXT_PUBLIC_API_URL;

  const WS_URL = process.env.NEXT_PUBLIC_WS_URL;

  const config = {
    BRANCH_NAME: process.env.CF_PAGES_BRANCH,

    BASE_URL: baseURL,

    ENABLE_COMING_SOON: process.env.NEXT_PUBLIC_ENABLE_COMING_SOON === 'true',

    CHAIN_NETWORK,

    REST_URL,

    WS_URL,

    RPC_URL: process.env.NEXT_PUBLIC_RPC_URL,

    WEB3: {
      clientId: process.env.NEXT_PUBLIC_WEB3_AUTH_CLIENT_ID,
    },
  };

  return AppConfigSchema.parse(config);
};
